import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WrapperSlider, StyledInputSlider, Output } from './style';

class InputSlider extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = { value: this.props.val };
  }

  onChange(event) {
    this.setState({ value: event.target.value });
    this.props.onChange(event.target.value);
  }

  controlBar = size => {
    const { val, max } = this.props;
    const value = !size ? val : size;
    return (100 * value) / max;
  };

  controlValue = () => {
    const { value } = this.state;
    const { val, max } = this.props;
    const maxi = !max ? 100 : max;
    if (!value) {
      return !val ? maxi / 2 : value;
    }
    return value;
  };

  render() {
    const { className, min, max } = this.props;
    return (
      <WrapperSlider className={className}>
        <StyledInputSlider
          max={!max ? 100 : max}
          min={!min ? 0 : min}
          value={this.controlValue()}
          onChange={this.onChange}
        />
        <Output valueSlider={this.controlBar(this.state.value)} />
      </WrapperSlider>
    );
  }
}

InputSlider.propTypes = {
  onChange: PropTypes.func,
  val: PropTypes.number,
  className: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number
};

export default InputSlider;
